import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const upgradeEditionButtonFragmentSpec: GraphQLTaggedNode = graphql`
	fragment UpgradeEditionButtonFragment on ConfluenceTenantContext {
		editions {
			confluence
			__typename
		}
		__typename
	}
`;
